import React, { forwardRef } from 'react'

import { Table } from 'Components/uiControls'

const byVehicles = forwardRef((props, ref) => {

    const {
        loading,
        columns,
        data,
        changeIdsCallback,
        searchText,
        onSelectedItems,
        onChangeColumns,
        onChangeSort,
        sort,
        onChangeRowsPerPage,
        rowsPerPage,
        moduleUnitSettings,
        columnsToExportPFF
    } = props

    return (

        <Table
            ref={ref}
            keyColumn="id"
            loading={loading}
            topheight={!moduleUnitSettings ? 180 : 238}
            columns={columns}
            data={data}
            searchText={searchText}
            onSelectedItems={onSelectedItems}
            onChangeDisplayData={(displayData) => {
                changeIdsCallback(displayData, "id")
            }}
            exportOrientation='landscape'
            exportName='fleet'
            onChangeColumns={onChangeColumns}
            onChangeSort={onChangeSort}
            sort={sort}
            onChangeRowsPerPage={onChangeRowsPerPage}
            rowsPerPage={rowsPerPage}
            hideAllInPagination={true}
            columnsToExportPFF={columnsToExportPFF}
        />
    )
})

export default byVehicles;